import { Component, EventEmitter, Input, OnInit, Output  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { Location } from '@angular/common';
import { InputData, ResultDataSet } from 'src/app/core/popupmessage/dynamicdialog/dynamicdialog.interface';
import { PopupService } from 'src/app/core/popupmessage/popupmessage.service';
import { UserService } from '../../services/user.service';

declare var $:any;

@Component({
    selector:'login',
    templateUrl:'login.component.html'
})
export class LoginComponent implements OnInit {

    @Input() item:InputData = {obj:null,configurationData:[]}
    @Output() clickAction = new EventEmitter<ResultDataSet>();
    username:string = "";
    password:string = "";
    isvalidLoggin:boolean = true;
    disableLoginButton:boolean = false;
    enterPass:boolean = false;
    errorMessage:string = ""

    constructor( private route:ActivatedRoute, private userService:UserService, private router:Router, private popUpSrv:PopupService, private location:Location){
    }

    public ngOnInit(){
        setTimeout(()=>{
            if(this.route.snapshot.routeConfig?.path == "login/verify"){
                console.log(this.route.snapshot.paramMap);
                this.popUpSrv.Loading("Verifying Credentrials", "Please Wait..",30,1);
                this.route.queryParams.subscribe(params=>{
                    console.log(params);
                    if(params["code"] !== null && params["code"].length > 0 && params["state"] !== null && params["state"].length > 0){
                        this.userService.verify(params["state"],params["code"]).then(()=>{
                            this.popUpSrv.close();
                            this.router.navigate(["/"]);
                        }).catch(()=>{
                            this.popUpSrv.close();
                            this.location.replaceState("/login");
                        })
                    }else{
                        this.popUpSrv.close();
                        this.location.replaceState("/login");
                    }
                })
            }else{
                this.isLoggedIn()
            }
        },500)
    }

    public login(){
        this.errorMessage = "";
        if( this.username !== ""){
            window.open(document.location.origin+'/api/auth/login?username='+this.username, '_self');
        }else{
            this.invalidLoginMessage("Username Required");
        }
    }

    public isLoggedIn(){
        this.userService.checkStatus().then(()=>{
            this.router.navigate([""]);
        }).catch((err)=>{
            console.log("stauts not valid")
        })
    }

    public invalidLoginMessage(message:string){
        this.errorMessage = message;
    };
};